const photoSource = (subType) => {

    switch (subType) {
        case 'Sale of Business':
            return 'business'
            
        case 'Development Site':
            return 'land'
            
        case 'Gas Station':
            return 'gasStation'
            
        case 'Hospitality':
            return 'motel'

        case 'Industrial':
            return 'industrial'
            
        case 'Land':
            return 'land'
            
        case 'Mobile Home Park':
            return 'mobilehomepark'
            
        case 'Medical Office':
            return 'medicalOffice'
            
        case 'Mixed Use':
            return 'mixedUse'
            
        case 'Multifamily':
            return 'multiFamily'
            
        case 'Office':
            return 'office'
            
        case 'Plaza':
            return 'plaza'
            
        case 'Retail':
            return 'retail'
            
        case 'Self Storage':
            return 'selfStorage'
            
        case 'Senior/Assisted Living':
            return 'seniorHome'
            
        case 'Special Purpose':
            return 'specialPurpose'
            
        case 'Store w/Apt/Office':
            return 'storeWapt'
            
        case 'Student Housing':
            return 'studentHousing'
            
        case 'Other':
            return 'mixedUse'
            
        default:
            return 'mixedUse'
        // code block
    }
}
 
export default photoSource;